import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { DeleteButton } from '../../../components/DeleteButton';
import * as Utils from '../../../utils/helper';
import { EditButton } from '../../../components/EditButton';
import { DownloadConfigurationButton } from './DownloadConfigurationButton';

import css from './DeviceEntry.module.scss';

export const DeviceEntry = ({ tenant, device, handleDelete, handleEdit }) => {

    const getLabelWithMaxLength = (label, maxLenght) => {
        if (!label) {
            return null;
        }

        if (label.length <= maxLenght) {
            return <>{label}</>
        }

        const labelTrimmed = label.substring(0, maxLenght - 2).trim() + "...";

        return <>
            <OverlayTrigger 
                placement='right'
                overlay={
                    <Tooltip>
                        {label}
                    </Tooltip>
                }
            >
                <span>{labelTrimmed}</span>
            </OverlayTrigger>
        </>;
    }
       
    return (
        <tr>
            <td>
                <div className={css.flexContainer}>
                    <div>
                        {getLabelWithMaxLength(device.deviceDescription, 100)}
                    </div>
                </div>
            </td>
            <td>
                <div className={css.flexContainer}>
                    <div>
                        {device.referenceId}
                    </div>
                </div>
            </td>
            <td className="align-middle">
                {Utils.isTrue(device.enabled) ? "yes" : "no"}
            </td>
            <td className="align-left">
                {device.contactGroupName}
            </td>
            <td className="align-left">
                {device.iqMessengerConnectionName}
            </td>
            <td className="align-middle">
                <DownloadConfigurationButton className="float-right mr-1" placement="top" deviceId={device.deviceId} />
                <DeleteButton className="float-right mr-1" placement="top" tooltip="Delete" onClick={() => handleDelete(device)} />
                <EditButton className="float-right mr-1" placement="top" tooltip="Edit" onClick={() => handleEdit(device)} />                
            </td>
        </tr>
    )
}